import { render, staticRenderFns } from "./editFee.vue?vue&type=template&id=c6f6a40a&scoped=true"
import script from "./editFee.vue?vue&type=script&lang=js"
export * from "./editFee.vue?vue&type=script&lang=js"
import style0 from "./editFee.vue?vue&type=style&index=0&id=c6f6a40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f6a40a",
  null
  
)

export default component.exports